var _defs, _rect, _circle, _rect2, _text, _circle2, _path, _text2, _text3, _rect3, _text4, _circle3, _circle4, _path2, _text5, _text6, _rect4, _text7, _circle5, _rect5, _path3, _text8, _text9, _rect6, _text0, _circle6, _circle7, _path4, _text1, _text10, _rect7, _text11, _circle8, _circle9, _path5, _text12, _text13, _rect8, _text14, _circle0, _circle1, _path6, _text15, _text16, _path7, _path8, _path9, _path0, _path1, _rect9, _circle10, _text17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkPassportRequirementsModelLiveRelationshipDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1440,
    height: 600,
    viewBox: "0 0 1440 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Work Passport requirements model desktop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "wp-model-glow"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087CFF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087CFF",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 600,
    rx: 40,
    fill: "#07152A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 720,
    cy: 288,
    r: 420,
    fill: "url(#wp-model-glow)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 150,
    width: 194,
    height: 280,
    rx: 24,
    fill: "#0B1D35",
    stroke: "#29405D"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 184,
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "01")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 139,
    cy: 242,
    r: 38,
    fill: "#087CFF",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124 255v-27h30v27M131 235h3m5 0h3m5 0h3M131 243h3m5 0h3m5 0h3M121 255h36",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 139,
    y: 310,
    textAnchor: "middle",
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "SITE")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 139,
    y: 346,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 17,
    fontWeight: 820,
    textAnchor: "middle",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 139,
    dy: 0
  }, "Configure each"), /*#__PURE__*/React.createElement("tspan", {
    x: 139,
    dy: 23
  }, "worksite"))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 150,
    width: 194,
    height: 280,
    rx: 24,
    fill: "#0B1D35",
    stroke: "#29405D"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 298,
    y: 184,
    fill: "#FF2775",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "02")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 371,
    cy: 242,
    r: 38,
    fill: "#FF2775",
    fillOpacity: 0.12
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 371,
    cy: 234,
    r: 7,
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M358 256c1-9 6-13 13-13s12 4 13 13M364 247l7 6 7-6",
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 371,
    y: 310,
    textAnchor: "middle",
    fill: "#FF2775",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "POSITION")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 371,
    y: 346,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 17,
    fontWeight: 820,
    textAnchor: "middle",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 371,
    dy: 0
  }, "Define each role"))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 506,
    y: 150,
    width: 194,
    height: 280,
    rx: 24,
    fill: "#0B1D35",
    stroke: "#29405D"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 530,
    y: 184,
    fill: "#F5B642",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "03")), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 603,
    cy: 242,
    r: 38,
    fill: "#F5B642",
    fillOpacity: 0.12
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 225,
    width: 28,
    height: 34,
    rx: 3,
    fill: "none",
    stroke: "#F5B642",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M596 234h14M596 241h9M596 250l4 4 9-10",
    fill: "none",
    stroke: "#F5B642",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 603,
    y: 310,
    textAnchor: "middle",
    fill: "#F5B642",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "REQUIREMENTS")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 603,
    y: 346,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 17,
    fontWeight: 820,
    textAnchor: "middle",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 603,
    dy: 0
  }, "Set current criteria"))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 738,
    y: 150,
    width: 194,
    height: 280,
    rx: 24,
    fill: "#0B1D35",
    stroke: "#29405D"
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 762,
    y: 184,
    fill: "#74BDFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "04")), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 835,
    cy: 242,
    r: 38,
    fill: "#74BDFF",
    fillOpacity: 0.12
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 835,
    cy: 233,
    r: 8,
    fill: "none",
    stroke: "#74BDFF",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M820 257c2-10 7-15 15-15s13 5 15 15",
    fill: "none",
    stroke: "#74BDFF",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 835,
    y: 310,
    textAnchor: "middle",
    fill: "#74BDFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "EMPLOYEE")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 835,
    y: 346,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 17,
    fontWeight: 820,
    textAnchor: "middle",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 835,
    dy: 0
  }, "Allocate the"), /*#__PURE__*/React.createElement("tspan", {
    x: 835,
    dy: 23
  }, "workforce"))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 970,
    y: 150,
    width: 194,
    height: 280,
    rx: 24,
    fill: "#0B1D35",
    stroke: "#29405D"
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 994,
    y: 184,
    fill: "#30D6A1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "05")), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1067,
    cy: 242,
    r: 38,
    fill: "#30D6A1",
    fillOpacity: 0.12
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 1067,
    cy: 242,
    r: 17,
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1067 232v11l8 5",
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 1067,
    y: 310,
    textAnchor: "middle",
    fill: "#30D6A1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "VALIDITY")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 1067,
    y: 346,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 17,
    fontWeight: 820,
    textAnchor: "middle",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1067,
    dy: 0
  }, "Track evidence"), /*#__PURE__*/React.createElement("tspan", {
    x: 1067,
    dy: 23
  }, "and expiry"))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1202,
    y: 150,
    width: 194,
    height: 280,
    rx: 24,
    fill: "#0B1D35",
    stroke: "#29405D"
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 1226,
    y: 184,
    fill: "#30D6A1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "06")), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 1299,
    cy: 242,
    r: 38,
    fill: "#30D6A1",
    fillOpacity: 0.12
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 1299,
    cy: 242,
    r: 17,
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1291 242l6 6 11-13",
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 1299,
    y: 310,
    textAnchor: "middle",
    fill: "#30D6A1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "READINESS")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 1299,
    y: 346,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 17,
    fontWeight: 820,
    textAnchor: "middle",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1299,
    dy: 0
  }, "Determine"), /*#__PURE__*/React.createElement("tspan", {
    x: 1299,
    dy: 23
  }, "deployment status"))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M236 290h38m-8-7 8 7-8 7",
    fill: "none",
    stroke: "#74BDFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M468 290h38m-8-7 8 7-8 7",
    fill: "none",
    stroke: "#74BDFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M700 290h38m-8-7 8 7-8 7",
    fill: "none",
    stroke: "#74BDFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M932 290h38m-8-7 8 7-8 7",
    fill: "none",
    stroke: "#74BDFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1164 290h38m-8-7 8 7-8 7",
    fill: "none",
    stroke: "#74BDFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 486,
    width: 1354,
    height: 2,
    fill: "#29405D"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 526,
    r: 6,
    fill: "#30D6A1"
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 532,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 700
  }, "A live model recalculates readiness whenever requirements, evidence or allocations change.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkPassportRequirementsModelLiveRelationshipDesktop);
export default __webpack_public_path__ + "static/media/work-passport-requirements-model-live-relationship-desktop.b719da6d235d4047aac4d98f3760ab5e.svg";
export { ForwardRef as ReactComponent };